<template>
  <div>
    <v-row>
      <v-col>
        <div class="text-h4 font-weight-bold my-2 text-darkblue">Actions</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-2">
        <div class="pa-1">
          <div class="d-flex flex-wrap gap">
            <v-card class="bg-grey_1">
              <template v-slot:title> Inscrire un participant</template>
              <template v-slot:subtitle>ou un groupe</template>
              <template v-slot:actions>
                <ButtonInscriptionAdmin></ButtonInscriptionAdmin>
              </template>
            </v-card>
            <!-- Inscription admin en billetterie si autorisée -->
            <v-card class="bg-grey_1" v-if="mainStore.module.autorise_acces_billetterie">
              <template v-slot:title> Inscrire un participant</template>
              <template v-slot:subtitle>en mode billetterie</template>
              <template v-slot:actions>
                <ButtonInscriptionBilletterieAdmin></ButtonInscriptionBilletterieAdmin>
              </template>
            </v-card>
            <v-card class="bg-grey_1">
              <template v-slot:title> Accèder aux fiches participants</template>
              <template v-slot:subtitle>au module</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'ListInscriptionsAdmin' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1"
              v-if="mainStore.module.has_preinscription || mainStore.module.some_races_have_preinscription || mainStore.module.preinscription_ended">
              <template v-slot:title> Accèder aux fiches des préinscrits</template>
              <template v-slot:subtitle>du module</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'ListPreInscriptionsAdmin' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1"
              v-if="mainStore.module.has_preinscription || mainStore.module.some_races_have_preinscription || mainStore.module.preinscription_ended">
              <template v-slot:title> Valider les préinscriptions</template>
              <template v-slot:subtitle>du module</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'ValidationPreInscriptionsAdmin' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Accèder</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1" v-if="mainStore.module.has_liste_attente_bourse">
              <template v-slot:title> Gérer la liste d'attente</template>
              <template v-slot:subtitle>de la bourse aux dossards</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'ListeAttenteBourseAdmin' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>

            <v-card class="bg-grey_1">
              <template v-slot:title> Valider les documents</template>
              <template v-slot:subtitle>des coureurs en attente</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'ValidationDocumentsAdmin' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1">
              <template v-slot:title> Liens d'inscription</template>
              <template v-slot:subtitle>privilégiés (Elites/Partenaires)</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'LienVIP' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1">
              <template v-slot:title> Liens de groupes</template>
              <template v-slot:subtitle>et suivi partenaire</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'LienGroupeInscription' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1">
              <template v-slot:title> Code promo et réductions</template>
              <template v-slot:subtitle>Consulter et créer</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'CodeReduction' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>

            <v-card class="bg-grey_1">
              <template v-slot:title> Exporter la liste des inscrits</template>
              <template v-slot:subtitle>au format EXCEL</template>
              <template v-slot:actions>
                <ButtonsExportsAdmin></ButtonsExportsAdmin>
              </template>
            </v-card>
            <v-card class="bg-grey_1" v-if="mainStore.module.has_accueil_qr_code">
              <template v-slot:title>Accueil des participants - Accès bénévoles</template>
              <template v-slot:subtitle>Donner l'accès aux bénévoles en scannant ce QR-Code</template>
              <template v-slot:actions>
                <div class="d-flex sm-gap">
                  <a target="_blank"
                    :href="base_url + 'Accueil_Sportips_App/QRCode_Accueil/get.php?id=' + mainStore.module.id"><v-btn
                      color="primary-dark" variant="outlined" density="compact">Télécharger</v-btn></a>
                  <a target="_blank" href="https://sportips.fr/inscription/img/explications_qr_code_accueil.jpg"><v-btn
                      color="primary-dark" variant="outlined" density="compact">Comment ça marche ?</v-btn></a>
                </div>
              </template>
            </v-card>

            <v-card class="bg-grey_1">
              <template v-slot:title> Consulter les prestations</template>
              <template v-slot:subtitle>proposées par Sportips</template>
              <template v-slot:actions>
                <a href="https://sportips.fr/presta/" target="_blank"><v-btn color="primary-dark" variant="outlined"
                    density="compact">Consulter</v-btn></a>
              </template>
            </v-card>
            <v-card class="bg-grey_1">
              <template v-slot:title> Lien d'accès au module</template>
              <template v-slot:subtitle>une fois fermé</template>
              <template v-slot:actions>
                <ButtonModuleFerme></ButtonModuleFerme>
              </template>
            </v-card>
            <v-card class="bg-grey_1">
              <template v-slot:title> Prévisualiser les podiums</template>
              <template v-slot:subtitle>à récompenser</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'PodiumsPreview' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1" v-if="mainStore.module.base == 'MAXIRACE26'">
              <template v-slot:title> Gérer les créneaux</template>
              <template v-slot:subtitle>de retrait de dossard</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'RetraitDossard' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>
            <v-card class="bg-grey_1">
              <template v-slot:title> Liste des inscrits</template>
              <template v-slot:subtitle>à plusieurs parcours</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'ListInscritsMultiParcours' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Consulter</v-btn>
                </router-link>
              </template>
            </v-card>

            <v-card class="bg-grey_1">
              <template v-slot:title> Editer la configuration</template>
              <template v-slot:subtitle>du module d'inscription</template>
              <template v-slot:actions>
                <router-link :to="{ name: 'ConfigurationModuleAdmin' }">
                  <v-btn color="primary-dark" variant="outlined" density="compact">Configurer</v-btn>
                </router-link>
              </template>
            </v-card>

          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import ButtonModuleFerme from "./ButtonModuleFerme.vue";
import ButtonsExportsAdmin from "./ButtonsExportsAdmin.vue";
import ButtonInscriptionAdmin from "./ButtonInscriptionAdmin.vue";
import ButtonInscriptionBilletterieAdmin from "./ButtonInscriptionBilletterieAdmin.vue";
export default {
  components: { ButtonModuleFerme, ButtonInscriptionAdmin, ButtonsExportsAdmin, ButtonInscriptionBilletterieAdmin },
  data() {
    return {
      base_url: process.env.VUE_APP_API_BASE,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
};
</script>

<style lang="scss">
.v-card-subtitle {
  font-size: 1rem !important;
  opacity: 1;
  color: black !important;
}
</style>